<template>
  <div>
    <el-table
        v-loading="dataListLoading"
        :data="dataList"
        border
        @selection-change="dataListSelectionChangeHandle"
        style="width: 100%;"
    >
      <el-table-column
          type="index"
          label="行号"
          header-align="center"
          align="center"
          width="50"
      ></el-table-column>
      <el-table-column
          prop="agreementCode"
          label="合同编号"
          header-align="center"
          align="center"
      ></el-table-column>
      <el-table-column
          prop="storageName"
          label="仓库名称"
          header-align="center"
          align="center"
          width="200"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          v-if="productType === '产品'"
          prop="code"
          label="品番号"
          header-align="center"
          align="center"
      ></el-table-column>
      <el-table-column
          prop="name"
          label="品名"
          header-align="center"
          align="center"
      ></el-table-column>
      <el-table-column
          prop="color"
          label="颜色"
          header-align="center"
          align="center"
      ></el-table-column>
      <el-table-column
          prop="size"
          label="规格"
          header-align="center"
          align="center"
      ></el-table-column>
      <el-table-column
          prop="attr1"
          label="幅宽"
          header-align="center"
          align="center"
          v-if="productType === '原料'"
      ></el-table-column>
      <el-table-column
          prop="attr2"
          label="克重"
          header-align="center"
          align="center"
          v-if="productType === '原料'"
      ></el-table-column>
      <el-table-column label="库存数量" header-align="center" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.count > 0?'success':'danger'" >{{
              scope.row.count
            }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" header-align="center" align="center" v-if="showOpt">
        <template v-slot="scope" >
          <slot name="opt-row" v-bind:row="scope.row"></slot>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle"
    >
    </el-pagination>
  </div>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'

export default {
  mixins: [mixinViewModule],
  props: {
    queryForm: {
      type: Object,
      default: () => {
        return {}
      },
    },
    productType: {
      type: String,
      default: '',
    },
    showOpt:{
      type:Boolean,
      default:true
    }
  },
  watch: {
    productType: {
      handler: function (newVal) {
        this.$set(this.dataForm, 'productType', newVal)
        if (newVal) {
          this.reload()
        }
      },
      immediate: true,
    },
    queryForm: {
      handler: function (newVal) {
        this.dataForm = {
          ...this.dataForm,
          ...newVal
        }
      },
      immediate: true,
      deep: true
    }
  },
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/store/page',
        getDataListIsPage: true,
      },
      dataForm: {},
    }
  },
  methods: {
    beforeTableBinding (dataList) {
      dataList.forEach((item) => {
      })
    },
  },
}
</script>
